import { ExportAmountType } from './autoexport-exportamount-type.model';

export class ExportAmountTypeItem {
    constructor(exportAmountType: ExportAmountType, exportAmountTypeText: string) {
        this.exportAmountType = exportAmountType;
        this.exportAmountTypeText = exportAmountTypeText;
    }

    exportAmountType: ExportAmountType;
    exportAmountTypeText: string;
}
